module.exports = __webpack_public_path__ + "img/goal03.257760ce.png";